export default "__VITE_ASSET__BBGKqkJn__"